import { render, staticRenderFns } from "./CategorySupplyDetails.vue?vue&type=template&id=2b012a72"
import script from "./CategorySupplyDetails.vue?vue&type=script&lang=js"
export * from "./CategorySupplyDetails.vue?vue&type=script&lang=js"
import style0 from "./CategorySupplyDetails.vue?vue&type=style&index=0&id=2b012a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports